/**
 * Máquina prevista de uma Operação — subcoleção.
 * Subcoleção: org/{orgId}/operation/{operationId}/operationMachine
 */
export const OPERATION_MACHINE = 'OperationMachine';
//# sourceMappingURL=operation-machine.js.map